import type {FC} from 'react';
import {Money} from '@dintero/money';

import {formatLocaleCurrency} from '@/shared/format';

import type {ItemWithVatTypeFragment} from './query';
import {getItemQuantityPriceWithVat} from './utils';

export type FormattedItemPriceProps = {
	items: ItemWithVatTypeFragment[];
	quantity?: number;
};

export const FormattedItemPrice: FC<FormattedItemPriceProps> = ({items, quantity = 1}) => {
	let finalPrice = Money.fromFractionlessAmount(0, 'NOK');

	for (const item of items) {
		if (!item.resolvedVatType) {
			continue;
		}

		const quanityPrice = getItemQuantityPriceWithVat(item, item.resolvedVatType, quantity);
		finalPrice = finalPrice.add(quanityPrice.amountIncVat);
	}

	return <>{formatLocaleCurrency(finalPrice.toFractionlessAmount())}</>;
};
